document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mt-producto]').forEach(initProducto);
});

function initProducto(root) {
  initGaleria(root);
  initVariantes(root);
}

function initGaleria(root) {
  var miniaturas = root.querySelectorAll('[data-mt-mini]');
  var principal = root.querySelector('[id^="mt-imagen-principal-"]');
  if (!miniaturas.length || !principal) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full) return;
      principal.src = full;
      miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantes(root) {
  var script = root.querySelector('[data-mt-variantes]');
  if (!script) return;
  var variantes;
  try {
    variantes = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }

  var botones = root.querySelectorAll('[data-mt-opcion-valor]');
  if (!botones.length) return;

  var inputId = root.querySelector('[data-mt-variant-id]');
  var precioEl = root.querySelector('[data-mt-precio]');
  var precioAnteriorEl = root.querySelector('[data-mt-precio-anterior]');
  var botonComprar = root.querySelector('[data-mt-boton-comprar]');
  var botonTexto = root.querySelector('[data-mt-boton-texto]');
  var principal = root.querySelector('[id^="mt-imagen-principal-"]');
  var miniaturas = root.querySelectorAll('[data-mt-mini]');

  function rutaBase(url) {
    return url ? url.split('?')[0] : '';
  }

  var seleccion = {};
  root.querySelectorAll('.mt-producto-opcion').forEach(function (grupo, index) {
    var activo = grupo.querySelector('.mt-opcion-valor.mt-activa');
    seleccion[index] = activo ? activo.getAttribute('data-mt-opcion-valor') : null;
  });

  function formatoMoneda(centavos) {
    var monto = centavos / 100;
    var formato = window.mtMoneyFormat || '';
    var sinDecimales = formato.indexOf('no_decimals') > -1;
    var locale = window.mtLocale || document.documentElement.lang || 'es';
    var moneda = window.mtCurrency || 'USD';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: moneda,
        minimumFractionDigits: sinDecimales ? 0 : 2,
        maximumFractionDigits: sinDecimales ? 0 : 2
      }).format(monto);
    } catch (e) {
      return '$' + monto.toFixed(sinDecimales ? 0 : 2);
    }
  }

  function actualizar() {
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;

    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (precioAnteriorEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnteriorEl.textContent = formatoMoneda(variante.compare_at_price);
        precioAnteriorEl.style.display = '';
      } else {
        precioAnteriorEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      if (botonTexto) {
        botonTexto.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible') || botonTexto.textContent
          : botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
    if (principal && variante.featured_image && variante.featured_image.src) {
      principal.src = variante.featured_image.src;
      var coincidencia = null;
      miniaturas.forEach(function (m) {
        m.classList.remove('mt-activa');
        if (rutaBase(m.getAttribute('data-full')) === rutaBase(variante.featured_image.src)) {
          coincidencia = m;
        }
      });
      if (coincidencia) coincidencia.classList.add('mt-activa');
    }
  }

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var index = boton.getAttribute('data-mt-opcion-index');
      var valor = boton.getAttribute('data-mt-opcion-valor');
      seleccion[index] = valor;
      boton.parentElement.querySelectorAll('.mt-opcion-valor').forEach(function (b) {
        b.classList.remove('mt-activa');
      });
      boton.classList.add('mt-activa');
      actualizar();
    });
  });
}
